"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Syndicate_abi__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "DuplicateArrayElements",
        type: "error",
    },
    {
        inputs: [],
        name: "EmptyArray",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedToTransfer",
        type: "error",
    },
    {
        inputs: [],
        name: "FreeFloatingStakeAmountTooSmall",
        type: "error",
    },
    {
        inputs: [],
        name: "InactiveKnot",
        type: "error",
    },
    {
        inputs: [],
        name: "InconsistentArrayLengths",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidNumberOfCollateralizedOwners",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidStakeAmount",
        type: "error",
    },
    {
        inputs: [],
        name: "KnotHasAlreadyBeenDeRegistered",
        type: "error",
    },
    {
        inputs: [],
        name: "KnotIsAlreadyRegistered",
        type: "error",
    },
    {
        inputs: [],
        name: "KnotIsFullyStakedWithFreeFloatingSlotTokens",
        type: "error",
    },
    {
        inputs: [],
        name: "KnotIsNotAssociatedWithAStakeHouse",
        type: "error",
    },
    {
        inputs: [],
        name: "KnotIsNotRegisteredWithSyndicate",
        type: "error",
    },
    {
        inputs: [],
        name: "NotKickedFromBeaconChain",
        type: "error",
    },
    {
        inputs: [],
        name: "NotPriorityStaker",
        type: "error",
    },
    {
        inputs: [],
        name: "NothingStaked",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "UnableToStakeFreeFloatingSlot",
        type: "error",
    },
    {
        inputs: [],
        name: "ZeroAddress",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [],
        name: "ActivationDistanceUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes",
                name: "BLSPubKey",
                type: "bytes",
            },
        ],
        name: "CollateralizedSLOTReCalibrated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "ContractDeployed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes",
                name: "BLSPubKey",
                type: "bytes",
            },
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "claim",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "bool",
                name: "isCollateralizedClaim",
                type: "bool",
            },
        ],
        name: "ETHClaimed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes",
                name: "BLSPubKey",
                type: "bytes",
            },
        ],
        name: "KNOTRegistered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes",
                name: "BLSPubKey",
                type: "bytes",
            },
        ],
        name: "KnotDeRegistered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "staker",
                type: "address",
            },
        ],
        name: "PriorityStakerRegistered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes",
                name: "BLSPubKey",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Staked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes",
                name: "BLSPubKey",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "UnStaked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "unprocessed",
                type: "uint256",
            },
        ],
        name: "UpdateAccruedETH",
        type: "event",
    },
    {
        inputs: [],
        name: "ACTIVATION_BATCH_SIZE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PRECISION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "accruedEarningPerCollateralizedSlotOwnerOfKnot",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "accumulatedETHPerCollateralizedSlotPerKnot",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "accumulatedETHPerFreeFloatingShare",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "activateProposers",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "activationBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "activationDistance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "activationPointer",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_priorityStakers",
                type: "address[]",
            },
        ],
        name: "addPriorityStakers",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_staker",
                type: "address",
            },
            {
                internalType: "bytes[]",
                name: "_blsPubKeys",
                type: "bytes[]",
            },
        ],
        name: "batchPreviewUnclaimedETHAsCollateralizedSlotOwner",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_staker",
                type: "address",
            },
            {
                internalType: "bytes[]",
                name: "_blsPubKeys",
                type: "bytes[]",
            },
        ],
        name: "batchPreviewUnclaimedETHAsFreeFloatingStaker",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_blsPubKeys",
                type: "bytes[]",
            },
        ],
        name: "batchUpdateCollateralizedSlotOwnersAccruedETH",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "calculateETHForFreeFloatingOrCollateralizedHolders",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "calculateNewAccumulatedETHPerCollateralizedSharePerKnot",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "calculateNewAccumulatedETHPerFreeFloatingShare",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_blsPubKey",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "_user",
                type: "address",
            },
        ],
        name: "calculateUnclaimedFreeFloatingETHShare",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_recipient",
                type: "address",
            },
            {
                internalType: "bytes[]",
                name: "_blsPubKeys",
                type: "bytes[]",
            },
        ],
        name: "claimAsCollateralizedSLOTOwner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_recipient",
                type: "address",
            },
            {
                internalType: "bytes[]",
                name: "_blsPubKeys",
                type: "bytes[]",
            },
        ],
        name: "claimAsStaker",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "claimedPerCollateralizedSlotOwnerOfKnot",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_blsPublicKeys",
                type: "bytes[]",
            },
        ],
        name: "deRegisterKnots",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getUnprocessedETHForAllCollateralizedSlot",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getUnprocessedETHForAllFreeFloatingSlot",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_blsPublicKeys",
                type: "bytes[]",
            },
        ],
        name: "informSyndicateKnotsAreKickedFromBeaconChain",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_contractOwner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_priorityStakingEndBlock",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "_priorityStakers",
                type: "address[]",
            },
            {
                internalType: "bytes[]",
                name: "_blsPubKeysForSyndicateKnots",
                type: "bytes[]",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "isKnotRegistered",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "isNoLongerPartOfSyndicate",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "isPriorityStaker",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "lastAccumulatedETHPerFreeFloatingShare",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lastSeenETHPerCollateralizedSlotPerKnot",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lastSeenETHPerFreeFloating",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "numberOfActiveKnots",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "numberOfRegisteredKnots",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "previewActivateableProposers",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "previewTotalFreeFloatingSharesToActivate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_staker",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_blsPubKey",
                type: "bytes",
            },
        ],
        name: "previewUnclaimedETHAsCollateralizedSlotOwner",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_staker",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_blsPubKey",
                type: "bytes",
            },
        ],
        name: "previewUnclaimedETHAsFreeFloatingStaker",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "priorityStakingEndBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "proposersToActivate",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_newBLSPublicKeyBeingRegistered",
                type: "bytes[]",
            },
        ],
        name: "registerKnotsToSyndicate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "sETHStakedBalanceForKnot",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "sETHTotalStakeForKnot",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "sETHUserClaimForKnot",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_blsPubKeys",
                type: "bytes[]",
            },
            {
                internalType: "uint256[]",
                name: "_sETHAmounts",
                type: "uint256[]",
            },
            {
                internalType: "address",
                name: "_onBehalfOf",
                type: "address",
            },
        ],
        name: "stake",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "totalClaimed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "totalETHProcessedPerCollateralizedKnot",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalETHReceived",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalFreeFloatingShares",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalProposersToActivate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_unclaimedETHRecipient",
                type: "address",
            },
            {
                internalType: "address",
                name: "_sETHRecipient",
                type: "address",
            },
            {
                internalType: "bytes[]",
                name: "_blsPubKeys",
                type: "bytes[]",
            },
            {
                internalType: "uint256[]",
                name: "_sETHAmounts",
                type: "uint256[]",
            },
        ],
        name: "unstake",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "updateAccruedETHPerShares",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_distance",
                type: "uint256",
            },
        ],
        name: "updateActivationDistanceInBlocks",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_blsPubKey",
                type: "bytes",
            },
        ],
        name: "updateCollateralizedSlotOwnersAccruedETH",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_endBlock",
                type: "uint256",
            },
        ],
        name: "updatePriorityStakingBlock",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
class Syndicate_abi__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.Syndicate_abi__factory = Syndicate_abi__factory;
Syndicate_abi__factory.abi = _abi;
